import React from 'react';
import { connect } from 'react-redux';

import classes from './InternationalTupleInner.scss';

import * as flightActions from '../../../../../store/actions/index';
import * as farePriceActions from '../../../../../store/actions/index';

const internationalTupleInner = (props) => {
    const totalTime = props.detail.tdu.substring(0, 2) + "h " + props.detail.tdu.substring(3, 5) + "m";
    console.log("Stopover", props.stopOver);
    return (
        <li className={`${[classes.FlightListItem, props.listIndex === 0 ? classes.FlightListItemActive : null ].join(' ')} u-flex justify-content-between u-relative u-cursorPointer`} onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            props.onUpdateIntRoundTripTuple(props.tupleIndex, props.listIndex, props.type);
            // props.onSetIntIds(props.departFid, props.returnFid);  
        }
        }>
            <div className={`u-flex justify-content-between u-width40Percent`}>
                <div className={`u-textColorDark u-fontSize13 u-fontWeightMedium`}>{props.detail.FS[0].dd}</div>
                <div className={`u-textColorLight`}>&mdash;</div>
                <div className={`u-textColorDark u-fontSize13 u-fontWeightMedium`}>{props.detail.FS[props.detail.FS.length-1].ad}</div>
            </div>
            <div className={`u-textColorLight u-fontSize13`}>{totalTime}</div>
            <div>{props.stopOver}</div>
        </li>
    );
}

const mapStateToProps = state => {
    return {
        isDepartFlight: state.roundTripSummary.isDepartFlight,
        isReturnFlight: state.roundTripSummary.isReturnFlight,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUpdateIntRoundTripTuple: (tupleIndex, listIndex, type) => dispatch(flightActions.updateIntRoundTripTuple(tupleIndex, listIndex, type)),
        onSetIntIds: (departId, returnId) => dispatch(farePriceActions.setIntIds(departId, returnId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(internationalTupleInner);


// WEBPACK FOOTER //
// ./src/components/Flight/InternationalTupleRoundTrip/InternationalTupleDetails/InternationalTupleInner/InternationalTupleInner.js